import type {SxProp} from '@primer/react'
import {Link, RelativeTime} from '@primer/react'

type AgoProps = {
  timestamp: Date
  linkUrl?: string
} & SxProp

export function Ago({timestamp, linkUrl, sx}: AgoProps): JSX.Element {
  return (
    <Link href={linkUrl} sx={{color: 'fg.muted', ...sx}}>
      <RelativeTime date={timestamp}>
        on {timestamp.toLocaleDateString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})}
      </RelativeTime>
    </Link>
  )
}

try{ Ago.displayName ||= 'Ago' } catch {}